import { SvelteStyleStoreFactory, StyleUtilities, getCheckForSlotted } from '@collectivehealth/dls-styles';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

function noop() {}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function subscribe(store) {
  for (var _len = arguments.length, callbacks = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    callbacks[_key - 1] = arguments[_key];
  }

  var unsub = store.subscribe.apply(store, callbacks);
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}

function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_data(text, data) {
  data = '' + data;
  if (text.data !== data) text.data = data;
}

var current_component;

function set_current_component(component) {
  current_component = component;
}

function get_current_component() {
  if (!current_component) throw new Error("Function called outside component initialization");
  return current_component;
}

function onMount(fn) {
  get_current_component().$$.on_mount.push(fn);
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

function flush() {
  var seen_callbacks = new Set();

  do {
    // first, call beforeUpdate functions
    // and update components
    while (dirty_components.length) {
      var component = dirty_components.shift();
      set_current_component(component);
      update(component.$$);
    }

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];

      if (!seen_callbacks.has(callback)) {
        callback(); // ...so guard against infinite loops

        seen_callbacks.add(callback);
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(children(options.target));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteElement;

if (typeof HTMLElement === 'function') {
  SvelteElement = /*#__PURE__*/function (_CustomElement2) {
    _inherits(SvelteElement, _CustomElement2);

    var _super = _createSuper(SvelteElement);

    function SvelteElement() {
      var _this;

      _classCallCheck(this, SvelteElement);

      _this = _super.call(this);

      _this.attachShadow({
        mode: 'open'
      });

      return _this;
    }

    _createClass(SvelteElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        // @ts-ignore todo: improve typings
        for (var key in this.$$.slotted) {
          // @ts-ignore todo: improve typings
          this.appendChild(this.$$.slotted[key]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
      }
    }, {
      key: "$on",
      value: function $on(type, callback) {
        // TODO should this delegate to addEventListener?
        var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return function () {
          var index = callbacks.indexOf(callback);
          if (index !== -1) callbacks.splice(index, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set() {// overridden by instance, if it has props
      }
    }]);

    return SvelteElement;
  }(_CustomElement);
}

var iconLabelText = "mc4238bc6a_iconLabelText";
var styles = ".mc4238bc6a_iconLabelText{border:0;clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap}";

var iconLabelStyleStore = SvelteStyleStoreFactory();
var subscribe$1 = iconLabelStyleStore.subscribe,
    addStyles = iconLabelStyleStore.addStyles;

addStyles([{
  attributeName: 'theme',
  attributeValue: 'visually-hidden-text',
  className: 'ignore',
  styles: styles,
  parts: {
    iconLabelText: iconLabelText
  }
}]);

var iconLabel = {
    "iconLabel": "mc763a3b50_iconLabel",
    "baseline": "mc763a3b50_baseline",
    "bottom": "mc763a3b50_bottom",
    "center": "mc763a3b50_center",
    "top": "mc763a3b50_top",
    "iconLabelGlyph": "mc763a3b50_iconLabelGlyph",
    "left": "mc763a3b50_left",
    "right": "mc763a3b50_right",
    "iconLabelText": "mc763a3b50_iconLabelText",
    "medium": "mc763a3b50_medium",
    "mini": "mc763a3b50_mini",
    "none": "mc763a3b50_none",
    "small": "mc763a3b50_small",
    "tiny": "mc763a3b50_tiny",
    "empty": "mc763a3b50_empty"
};
var iconLabel$1 = "mc763a3b50_iconLabel";
var baseline = "mc763a3b50_baseline";
var bottom = "mc763a3b50_bottom";
var center = "mc763a3b50_center";
var top = "mc763a3b50_top";
var iconLabelGlyph = "mc763a3b50_iconLabelGlyph";
var left = "mc763a3b50_left";
var right = "mc763a3b50_right";
var iconLabelText$1 = "mc763a3b50_iconLabelText";
var medium = "mc763a3b50_medium";
var mini = "mc763a3b50_mini";
var none = "mc763a3b50_none";
var small = "mc763a3b50_small";
var tiny = "mc763a3b50_tiny";
var empty = "mc763a3b50_empty";
var styles$1 = ":host{display:inline-block}dls-icon-label{display:inline-block}[data-style]{display:none}.mc763a3b50_iconLabel{display:flex}.mc763a3b50_iconLabel slot{display:block}.mc763a3b50_iconLabel.mc763a3b50_baseline{align-items:baseline}.mc763a3b50_iconLabel.mc763a3b50_bottom{align-items:flex-end}.mc763a3b50_iconLabel.mc763a3b50_center{align-items:center}.mc763a3b50_iconLabel.mc763a3b50_top{align-items:flex-start}.mc763a3b50_iconLabelGlyph.mc763a3b50_left{order:-1}.mc763a3b50_iconLabelGlyph.mc763a3b50_right{order:1}.mc763a3b50_iconLabelText{order:0}.mc763a3b50_iconLabelText.mc763a3b50_left.mc763a3b50_medium{margin-left:24px}.mc763a3b50_iconLabelText.mc763a3b50_left.mc763a3b50_mini{margin-left:8px}.mc763a3b50_iconLabelText.mc763a3b50_left.mc763a3b50_none{margin-left:0}.mc763a3b50_iconLabelText.mc763a3b50_left.mc763a3b50_small{margin-left:16px}.mc763a3b50_iconLabelText.mc763a3b50_left.mc763a3b50_tiny{margin-left:12px}.mc763a3b50_iconLabelText.mc763a3b50_right.mc763a3b50_medium{margin-right:24px}.mc763a3b50_iconLabelText.mc763a3b50_right.mc763a3b50_mini{margin-right:8px}.mc763a3b50_iconLabelText.mc763a3b50_right.mc763a3b50_none{margin-right:0}.mc763a3b50_iconLabelText.mc763a3b50_right.mc763a3b50_small{margin-right:16px}.mc763a3b50_iconLabelText.mc763a3b50_right.mc763a3b50_tiny{margin-right:12px}.mc763a3b50_iconLabelGlyph.mc763a3b50_empty,.mc763a3b50_iconLabelText.mc763a3b50_empty{display:none}.mc763a3b50_iconLabelGlyph.mc763a3b50_empty+.mc763a3b50_iconLabelText.mc763a3b50_left{margin-left:0}.mc763a3b50_iconLabelGlyph.mc763a3b50_empty+.mc763a3b50_iconLabelText.mc763a3b50_right{margin-right:0}";

var iconLabelStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': iconLabel,
  iconLabel: iconLabel$1,
  baseline: baseline,
  bottom: bottom,
  center: center,
  top: top,
  iconLabelGlyph: iconLabelGlyph,
  left: left,
  right: right,
  iconLabelText: iconLabelText$1,
  medium: medium,
  mini: mini,
  none: none,
  small: small,
  tiny: tiny,
  empty: empty,
  styles: styles$1
});

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function create_if_block(ctx) {
  var slot0;
  var t0;
  var t1;
  var slot1;
  var dispose;
  return {
    c: function c() {
      slot0 = element("slot");
      t0 = text(
      /*formattedText*/
      ctx[8]);
      t1 = space();
      slot1 = element("slot");
      attr(slot0, "name", "icon-label-text");
    },
    m: function m(target, anchor) {
      insert(target, slot0, anchor);
      append(slot0, t0);
      insert(target, t1, anchor);
      insert(target, slot1, anchor);
      dispose = [listen(slot0, "slotchange",
      /*checkForSlotted*/
      ctx[12]), listen(slot1, "slotchange",
      /*checkForSlotted*/
      ctx[12])];
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*formattedText*/
      256) set_data(t0,
      /*formattedText*/
      ctx[8]);
    },
    d: function d(detaching) {
      if (detaching) detach(slot0);
      if (detaching) detach(t1);
      if (detaching) detach(slot1);
      run_all(dispose);
    }
  };
}

function create_fragment(ctx) {
  var div4;
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[9].sheet("theme/".concat(
  /*theme*/
  ctx[3])) + "";
  var t1;
  var div2;
  var slot;
  var div2_class_value;
  var t2;
  var div3;
  var div3_class_value;
  var div4_class_value;
  var dispose;
  var if_block =
  /*mounted*/
  ctx[4] && create_if_block(ctx);
  return {
    c: function c() {
      div4 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      div2 = element("div");
      slot = element("slot");
      t2 = space();
      div3 = element("div");
      if (if_block) if_block.c();
      this.c = noop;
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(slot, "name", "icon-label-glyph");
      attr(div2, "class", div2_class_value = "" + (
      /*style*/
      ctx[11].is("iconLabelGlyph") + " " +
      /*style*/
      ctx[11].if("empty", !
      /*hasGlyph*/
      ctx[5]) + " " +
      /*style*/
      ctx[11].is(
      /*position*/
      ctx[1]) + " " +
      /*$altStyles*/
      ctx[9].part("theme/".concat(
      /*theme*/
      ctx[3], "/iconLabelGlyph"))));
      attr(div3, "class", div3_class_value = "" + (
      /*style*/
      ctx[11].is("iconLabelText") + " " +
      /*style*/
      ctx[11].if("empty", !
      /*hasText*/
      ctx[7]) + " " +
      /*style*/
      ctx[11].is(
      /*space*/
      ctx[2]) + " " +
      /*style*/
      ctx[11].is(
      /*position*/
      ctx[1]) + " " +
      /*$altStyles*/
      ctx[9].part("theme/".concat(
      /*theme*/
      ctx[3], "/iconLabelText"))));
      attr(div4, "class", div4_class_value = "" + (
      /*style*/
      ctx[11].is("iconLabel") + " " +
      /*style*/
      ctx[11].is(
      /*align*/
      ctx[0]) + " " +
      /*$altStyles*/
      ctx[9].part("theme/".concat(
      /*theme*/
      ctx[3], "/iconLabel"))));
    },
    m: function m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div0);
      div0.innerHTML =
      /*stylesheet*/
      ctx[10];
      append(div4, t0);
      append(div4, div1);
      div1.innerHTML = raw1_value;
      append(div4, t1);
      append(div4, div2);
      append(div2, slot);
      slot.innerHTML =
      /*formattedGlyph*/
      ctx[6];
      append(div4, t2);
      append(div4, div3);
      if (if_block) if_block.m(div3, null);
      dispose = listen(slot, "slotchange",
      /*checkForSlotted*/
      ctx[12]);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*$altStyles, theme*/
      520 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[9].sheet("theme/".concat(
      /*theme*/
      ctx[3])) + "")) div1.innerHTML = raw1_value;
      if (dirty &
      /*formattedGlyph*/
      64) slot.innerHTML =
      /*formattedGlyph*/
      ctx[6];

      if (dirty &
      /*hasGlyph, position, $altStyles, theme*/
      554 && div2_class_value !== (div2_class_value = "" + (
      /*style*/
      ctx[11].is("iconLabelGlyph") + " " +
      /*style*/
      ctx[11].if("empty", !
      /*hasGlyph*/
      ctx[5]) + " " +
      /*style*/
      ctx[11].is(
      /*position*/
      ctx[1]) + " " +
      /*$altStyles*/
      ctx[9].part("theme/".concat(
      /*theme*/
      ctx[3], "/iconLabelGlyph"))))) {
        attr(div2, "class", div2_class_value);
      }

      if (
      /*mounted*/
      ctx[4]) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block(ctx);
          if_block.c();
          if_block.m(div3, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }

      if (dirty &
      /*hasText, space, position, $altStyles, theme*/
      654 && div3_class_value !== (div3_class_value = "" + (
      /*style*/
      ctx[11].is("iconLabelText") + " " +
      /*style*/
      ctx[11].if("empty", !
      /*hasText*/
      ctx[7]) + " " +
      /*style*/
      ctx[11].is(
      /*space*/
      ctx[2]) + " " +
      /*style*/
      ctx[11].is(
      /*position*/
      ctx[1]) + " " +
      /*$altStyles*/
      ctx[9].part("theme/".concat(
      /*theme*/
      ctx[3], "/iconLabelText"))))) {
        attr(div3, "class", div3_class_value);
      }

      if (dirty &
      /*align, $altStyles, theme*/
      521 && div4_class_value !== (div4_class_value = "" + (
      /*style*/
      ctx[11].is("iconLabel") + " " +
      /*style*/
      ctx[11].is(
      /*align*/
      ctx[0]) + " " +
      /*$altStyles*/
      ctx[9].part("theme/".concat(
      /*theme*/
      ctx[3], "/iconLabel"))))) {
        attr(div4, "class", div4_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div4);
      if (if_block) if_block.d();
      dispose();
    }
  };
}

function instance($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, iconLabelStyleStore, function ($$value) {
    return $$invalidate(9, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$1, "</style>");
  var style = new StyleUtilities(iconLabelStyles);
  var checkForSlotted = getCheckForSlotted(style.is("empty")); // In order to solve issues on Safari (iOS and Web), we need to render
  // some slots after the component is mounted.
  // https://jira.collectivehealth.com/browse/CH-59582
  // https://jira.collectivehealth.com/browse/CH-61300

  var matchesSafari = navigator.userAgent.indexOf("AppleWebKit") > 0 && navigator.userAgent.indexOf("Chrome") === -1;
  var mounted = matchesSafari === null;
  onMount(function () {
    if (!mounted) {
      setTimeout(function () {
        $$invalidate(4, mounted = true);
      }, 1);
    }
  });
  var _$$props$align = $$props.align,
      align = _$$props$align === void 0 ? "center" : _$$props$align;
  var _$$props$glyph = $$props.glyph,
      glyph = _$$props$glyph === void 0 ? "" : _$$props$glyph;
  var _$$props$position = $$props.position,
      position = _$$props$position === void 0 ? "left" : _$$props$position;
  var _$$props$space = $$props.space,
      space = _$$props$space === void 0 ? "mini" : _$$props$space;
  var _$$props$text = $$props.text,
      text = _$$props$text === void 0 ? "" : _$$props$text;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;

  $$self.$set = function ($$props) {
    if ("align" in $$props) $$invalidate(0, align = $$props.align);
    if ("glyph" in $$props) $$invalidate(13, glyph = $$props.glyph);
    if ("position" in $$props) $$invalidate(1, position = $$props.position);
    if ("space" in $$props) $$invalidate(2, space = $$props.space);
    if ("text" in $$props) $$invalidate(14, text = $$props.text);
    if ("theme" in $$props) $$invalidate(3, theme = $$props.theme);
  };

  var hasGlyph;
  var formattedGlyph;
  var hasText;
  var formattedText;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*glyph*/
    8192) {
       $$invalidate(5, hasGlyph = Boolean(glyph && typeof glyph === "string" && glyph.length));
    }

    if ($$self.$$.dirty &
    /*hasGlyph, glyph*/
    8224) {
       $$invalidate(6, formattedGlyph = hasGlyph ? "<dls-icon-".concat(glyph, "></dls-icon-").concat(glyph, ">") : "");
    }

    if ($$self.$$.dirty &
    /*text*/
    16384) {
       $$invalidate(7, hasText = Boolean(text && typeof text === "string" && text.length));
    }

    if ($$self.$$.dirty &
    /*hasText, text*/
    16512) {
       $$invalidate(8, formattedText = hasText ? text : "");
    }
  };

  return [align, position, space, theme, mounted, hasGlyph, formattedGlyph, hasText, formattedText, $altStyles, stylesheet, style, checkForSlotted, glyph, text];
}

var DlsIconLabel = /*#__PURE__*/function (_SvelteElement) {
  _inherits(DlsIconLabel, _SvelteElement);

  var _super = _createSuper$1(DlsIconLabel);

  function DlsIconLabel(options) {
    var _this;

    _classCallCheck(this, DlsIconLabel);

    _this = _super.call(this);
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance, create_fragment, safe_not_equal, {
      align: 0,
      glyph: 13,
      position: 1,
      space: 2,
      text: 14,
      theme: 3
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsIconLabel, [{
    key: "align",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(align) {
      this.$set({
        align: align
      });
      flush();
    }
  }, {
    key: "glyph",
    get: function get() {
      return this.$$.ctx[13];
    },
    set: function set(glyph) {
      this.$set({
        glyph: glyph
      });
      flush();
    }
  }, {
    key: "position",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(position) {
      this.$set({
        position: position
      });
      flush();
    }
  }, {
    key: "space",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(space) {
      this.$set({
        space: space
      });
      flush();
    }
  }, {
    key: "text",
    get: function get() {
      return this.$$.ctx[14];
    },
    set: function set(text) {
      this.$set({
        text: text
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["align", "glyph", "position", "space", "text", "theme"];
    }
  }]);

  return DlsIconLabel;
}(SvelteElement);

var _DEFAULTS;
var tagName = 'dls-icon-label';
var ATTRIBUTES = {
  SPACE: 'space',
  POSITION: 'position'
};
var DEFAULTS = (_DEFAULTS = {}, _defineProperty(_DEFAULTS, ATTRIBUTES.SPACE, 'mini'), _defineProperty(_DEFAULTS, ATTRIBUTES.POSITION, 'left'), _DEFAULTS);
var SLOT_NAMES = {
  GLYPH: 'icon-label-glyph',
  TEXT: 'icon-label-text'
}; // TODO: remove later, will be breaking change

DlsIconLabel.addStyles = addStyles; // TODO: create shared utility later
// TODO: don't call by default later, will be breaking change

try {
  window.customElements.define(tagName, DlsIconLabel);
} catch (error) {// TODO: See https://github.com/collectivehealth/dls/issues/552
  // eslint-disable-next-line no-console
  // console.error(
  //   `Your bundle may include ${tagName} more than once.`,
  //   error
  // );
}

export default DlsIconLabel;
export { ATTRIBUTES, DEFAULTS, SLOT_NAMES, tagName as TAG_NAME, addStyles };
